module.exports = __webpack_public_path__ + "img/news-横幅广告-25年职称辅导课.617dc537.jpg";